import { lazy } from 'react';
import { useKFlags } from '@/hooks/use-k-flags';

// Lazy-loaded report components
const ReportsV2 = lazy(() => import('@/pages/reports/non-ats-reports/home'));
const FlowHealthHome = lazy(() => import('@/pages/reports/non-ats-reports/flow-health'));
const DiversityHome = lazy(() => import('@/pages/reports/non-ats-reports/diversity'));
const KpiHome = lazy(() => import('@/pages/reports/non-ats-reports/kpi'));
const TeamProductivityHome = lazy(
  () => import('@/pages/reports/non-ats-reports/team-productivity')
);
const AtsHome = lazy(() => import('@/pages/reports/non-ats-reports/ats'));
const ReportsHome = lazy(() => import('@/pages/reports/ats-reports/home'));
const ReportsV3Comp = lazy(() => import('@/pages/reports/reports-main'));

export const STATIC_REPORT_CONFIGS = [
  { id: 'hires', title: 'Hires' },
  { id: 'flow-health', title: 'Flow Health' },
  { id: 'rejections', title: 'Rejections' },
  { id: 'interviews', title: 'Interviews' },
  { id: 'offers', title: 'Offers' },
  { id: 'jobs', title: 'Jobs' },
  { id: 'contacts', title: 'Contacts' },
  { id: 'live_job_pipeline', title: 'Current job pipeline' },
  { id: 'pipeline', title: 'Pipeline' },
  { id: 'eeo', title: 'EEO' },
  { id: 'requisitions', title: 'Requisitions' },
  { id: 'recruiter-performance', title: 'Recruiter performance' },
];

export const useReportsRoutes = () => {
  const { ats_enabled } = useKFlags();

  // feReportsV3 only: always use ReportsV3Comp for static reports
  const AtsLatestComponent = ReportsV3Comp;

  const nonAtsRoutes = [
    {
      route: '/reports-home',
      component: ReportsV2,
      title: 'Reports | Kula AI',
      id: 'reports-home',
    },
    {
      route: '/reports/flow-health',
      component: FlowHealthHome,
      title: 'Flow Health | Reports | Kula AI',
      id: 'flow-health',
    },
    {
      route: '/reports/diversity',
      component: DiversityHome,
      title: 'Diversity | Reports | Kula AI',
      id: 'diversity',
    },
    {
      route: '/reports/kpi',
      component: KpiHome,
      title: 'KPI | Reports | Kula AI',
      id: 'kpi',
    },
    {
      route: '/reports/team-productivity',
      component: TeamProductivityHome,
      title: 'Team Productivity | Reports | Kula AI',
      id: 'team-productivity',
    },
    {
      route: '/reports/ats',
      component: AtsHome,
      title: 'ATS | Reports | Kula AI',
      id: 'ats',
    },
  ];

  // Report configurations for dynamic route generation

  // Generate dynamic routes for all /reports/:id paths
  const dynamicAtsRoutes = STATIC_REPORT_CONFIGS.map(({ id, title }) => ({
    route: `/reports/${id}`,
    component: AtsLatestComponent,
    title: `${title} | Reports | Kula AI`,
    id,
  }));

  const atsRoutes = [
    ...dynamicAtsRoutes,
    {
      route: '/reports',
      component: ReportsHome,
      title: 'Reports | Kula AI',
      exact: true,
    },
  ];

  // Custom reports routes - always use ReportsV3Comp
  const customReportsRoutes = [
    {
      route: '/reports/:reportID',
      component: ReportsV3Comp,
      title: 'Reports | Kula AI',
      skipTitleUpdate: true,
    },
  ];

  const finalRoutes = ats_enabled
    ? [...atsRoutes, ...customReportsRoutes]
    : nonAtsRoutes;

  return {
    routes: finalRoutes,
  };
};
